var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography, Paper, CircularProgress, Button, Container, Alert, } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { verifyEmailAsync } from '../redux/accountSlice';
export const VerifyEmailPage = () => {
    const { token } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isMounted, setIsMounted] = useState(false);
    const [isVerifying, setIsVerifying] = useState(false);
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success',
    });
    useEffect(() => {
        setIsMounted(true);
        if (token) {
            verifyEmail();
        }
        return () => {
            setIsMounted(false);
        };
    }, [token]);
    const verifyEmail = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!token) {
            return;
        }
        setIsVerifying(true);
        try {
            yield dispatch(verifyEmailAsync(token)).unwrap();
            setIsVerifying(false);
            setSnackbar({
                open: true,
                message: 'Email verified successfully.',
                severity: 'success',
            });
            setTimeout(() => {
                if (isMounted) {
                    navigate('/account');
                }
            }, 3000);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }
        catch (error) {
            setIsVerifying(false);
            setSnackbar({
                open: true,
                message: error.message || 'Email verification failed.',
                severity: 'error',
            });
        }
    });
    return (_jsx(Container, Object.assign({ sx: {
            width: '100%',
            minHeight: 'calc(100vh - 64px)',
            paddingTop: {
                xs: 'calc(32px + 56px)',
                md: 'calc(32px + 64px)',
            },
            paddingBottom: '32px',
            px: { xs: 6, sm: 0 },
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        } }, { children: _jsxs(Paper, Object.assign({ elevation: 3, sx: {
                width: '100%',
                maxWidth: '360px',
                padding: 4,
                margin: 'auto',
            } }, { children: [_jsx(Typography, Object.assign({ variant: "h5", textAlign: "left" }, { children: "Email verification" })), _jsxs(Box, Object.assign({ mt: 4 }, { children: [isVerifying && (_jsxs(_Fragment, { children: [_jsx(CircularProgress, {}), _jsx(Typography, Object.assign({ variant: "body1" }, { children: "Please wait while we verify your email..." }))] })), snackbar.open && (_jsx(Alert, Object.assign({ severity: snackbar.severity }, { children: snackbar.message }))), !isVerifying && (_jsx(Button, Object.assign({ variant: "contained", color: "primary", onClick: () => navigate('/account'), sx: { mt: 4 } }, { children: "Go to Account" })))] }))] })) })));
};
